export default class Menu {
	constructor() {
		this.topBar = document.querySelector('.topbar');
		this.menuMobile = document.querySelector('.topbar__menu-mobile');
		this.trigger = '[aria-controls="menu"]';

		this.handleClick();
		this.onScrollBehavior();
	}

	toggleMenu() {
		const menuToggle = document.querySelector(this.trigger);
		const isExpanded = menuToggle.getAttribute('aria-expanded') === 'true';

		this.resetMobileSubMenus();

		document.documentElement.toggleAttribute('menu-open', !isExpanded);
		menuToggle.setAttribute('aria-expanded', !isExpanded);
		this.menuMobile.setAttribute('aria-hidden', isExpanded);
	}

	toggleMegaMenu(toggle) {
		const megaMenuToggle = toggle.closest('.-has-sub').querySelector('.mega-menu');
		const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

		this.resetMegaMenus();

		toggle.setAttribute('aria-expanded', !isExpanded);
		megaMenuToggle.setAttribute('aria-hidden', isExpanded);
	}

	resetMegaMenus() {
		const megaMenus = document.querySelectorAll('.mega-menu');

		megaMenus.forEach(megaMenu => {
			const toggle = megaMenu.closest('.-has-sub').querySelector('.mega-menu__toggle');
			toggle.setAttribute('aria-expanded', false);
			megaMenu.setAttribute('aria-hidden', true);
		});
	}

	resetMobileSubMenus() {
		const subMenus = document.querySelectorAll('.-has-sub');
		subMenus.forEach(subMenu => {
			subMenu.classList.remove('-active');
		});
	}

	handleClick() {
		document.addEventListener('click', event => {
			if(event.target.closest(this.trigger)) {
				event.preventDefault();
				this.toggleMenu();

				return;
			}

			if(event.target.closest('[aria-controls]') && event.target.closest('.-has-sub')) {
				event.preventDefault();

				if(event.target.closest('.mega-menu__toggle')) {
					this.toggleMegaMenu(event.target.closest('.mega-menu__toggle'));
					return;
				}

				const subTrigger = event.target.closest('.-has-sub').querySelector('[aria-controls]')
				subTrigger.closest('.-has-sub').classList.toggle('-active');

				return;
			}

			if(!event.target.closest('.mega-menu') && document.querySelector('.mega-menu[aria-hidden="false"]')) {
				this.resetMegaMenus();

				return;
			}

			return;
		});
	}

	onScrollBehavior() {
		let lastScroll = window.scrollY || document.documentElement.scrollTop;
		const scrollUpThreshold = 5;
		const offset = 100;

		window.addEventListener('scroll', e => {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const topBar = this.topBar;

			if(scrollTop > offset) {
				topBar.classList.add('-hidden');

				if (lastScroll - scrollTop > scrollUpThreshold) {
					topBar.classList.add('-fixed');
				}

				if(scrollTop - lastScroll > scrollUpThreshold) {
					topBar.classList.remove('-fixed');
					this.resetMegaMenus();
				}
			} else {
				topBar.classList.remove('-hidden', '-fixed');

				return;
			}

			lastScroll = scrollTop <= 0 ? 0 : scrollTop;
		});
	}
}
